import type {
  UseFormValidationParams,
  UseFormValidationReturn,
  ValidationErrors,
  FormValidationResult,
} from "./form-validation.type";

import { validationErrorParser } from "./form-validation.helper";

export const useFormValidation = (
  isError: UseFormValidationParams["isError"],
  error: UseFormValidationParams["error"],
  fieldNames: UseFormValidationParams["fieldNames"]
): UseFormValidationReturn => {
  const validationErrors = (): ValidationErrors =>
    isError && error
      ? validationErrorParser(error, fieldNames, "others")
      : ({} as ValidationErrors);

  const validation = (item: string): FormValidationResult => {
    const error = validationErrors()?.[item];
    return error ? { validateStatus: "error", help: error } : {};
  };

  return {
    validation,
    validationErrors,
  };
};
